import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const IBM_SKILLSBUILD_URL = 'https://skills.yourlearning.ibm.com/activity/ALM-COURSE_4076311?ngo-id=0516';

const ClaimSkillsBuildPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (sessionStorage.getItem('skillsbuild_claimed')) {
      sessionStorage.removeItem('skillsbuild_claimed');
      navigate('/onboarding');
    }
  }, [navigate]);

  const handleClaim = async () => {
    sessionStorage.setItem('skillsbuild_claimed', 'true');
    // Track the claim click before redirecting — await so request completes before navigation
    try {
      await axios.post('/api/tracking/skillsbuild-claim');
    } catch (err) {
      console.error('Failed to track claim:', err);
    }
    window.location.href = IBM_SKILLSBUILD_URL;
  };

  const handleAlreadyHaveAccount = () => {
    sessionStorage.setItem('skipped_claim', 'true');
    navigate('/onboarding');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-white px-4 py-6 sm:py-12">
      <div className="max-w-lg w-full text-center space-y-4 sm:space-y-8">
        <img
          src="/images/newimage.png"
          alt="Claim Your Student Pass - IBM SkillsBuild"
          className="w-full mx-auto rounded-xl shadow-2xl"
        />

        <h1 className="text-2xl sm:text-3xl font-extrabold text-[#054581] leading-tight">
          CLAIM YOUR STUDENT PASS<br />
          <span className="text-[#1db5d4]">IBM SKILLSBUILD</span>
        </h1>

        <div className="space-y-4">
          <button
            onClick={handleClaim}
            className="w-full py-3 px-6 bg-[#1db5d4] hover:bg-[#16a2c7] text-white font-semibold rounded-lg transition-colors duration-200 shadow-lg text-lg"
          >
            Claim My Account Now
          </button>

          <button
            onClick={handleAlreadyHaveAccount}
            className="text-gray-500 hover:text-[#054581] underline text-sm transition-colors duration-200"
          >
            I already have an IBM SkillsBuild account
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClaimSkillsBuildPage;
